import { GripVertical } from 'lucide-react'

interface ResumeDetailSplitResizeHandleProps {
  onPointerDown: (event: React.PointerEvent<HTMLButtonElement>) => void
  isResizing: boolean
}

export default function ResumeDetailSplitResizeHandle({
  onPointerDown,
  isResizing,
}: ResumeDetailSplitResizeHandleProps) {
  return (
    <button
      type="button"
      aria-label="Изменить ширину колонок редактора и превью"
      title="Перетащите, чтобы изменить ширину колонок"
      className={`resume-detail-split-resize-handle shrink-0 border-0 p-0 bg-transparent ${
        isResizing ? 'resume-detail-split-resize-handle--active' : ''
      }`}
      onPointerDown={onPointerDown}
    >
      <span className="resume-detail-split-resize-grip" aria-hidden="true">
        <GripVertical className="resume-detail-split-resize-grip-icon" strokeWidth={2} />
      </span>
    </button>
  )
}
